import { forwardRef } from "react"


export const BoundingBox = forwardRef(({ boundingBox, ...rest }, fRef) => {

    return (
        <div
            ref={fRef}
            {...rest}
            className={`bounding-box`}
        />
    )
})